import { Box } from '@mui/material';
import { ReactComponent as EditIcon } from '../../assets/images/edit.svg';
import { VesselInterface } from '../../utils/types/vessel';
import { MRT_ColumnDef } from 'material-react-table';
import { UserInterface } from '../../utils/types/user';
import IconButton from '@mui/material/IconButton';
import StatusSlot from '../../components/number-slot/StatusSlot';
import { getInactiveVesselTextStyle } from '../../utils/tableRowStyles';

const getOwnerLabel = (owner: UserInterface | UserInterface[] | undefined) => {
  if (Array.isArray(owner)) {
    return owner.length ? owner.map((o) => `${o.name} ${o.lastName}`).join(', ') : '--';
  }
  return owner ? `${owner.name} ${owner.lastName}` : '--';
};

const getVesselsGridColumns = (
  onEditVessel: (checklist: VesselInterface) => void
): Array<MRT_ColumnDef<VesselInterface>> => [
  {
    accessorKey: 'hullNumber',
    header: 'Hull Number',
    Cell: ({ cell, row }) => (
      <span style={getInactiveVesselTextStyle(row.original.active)}>{cell.getValue<string>()}</span>
    )
  },
  {
    accessorKey: 'name',
    header: 'Name',
    Cell: ({ cell, row }) => (
      <span style={getInactiveVesselTextStyle(row.original.active)}>{cell.getValue<string>()}</span>
    )
  },
  {
    accessorKey: 'owner',
    header: 'Owner',
    enableSorting: false,
    Cell: ({ cell, row }) => (
      <span style={getInactiveVesselTextStyle(row.original.active)}>
        {getOwnerLabel(cell.getValue<UserInterface | UserInterface[]>())}
      </span>
    )
  },
  {
    header: 'Actions',
    enableSorting: false,
    Cell: ({ row }) => {
      const vessel = row.original;
      const isInactive = vessel.active === false;

      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
          {isInactive && (
            <StatusSlot
              value="Inactive"
              backgroundSlot="#D4D9E6"
              backgroundValue="#273F82"
              fontSize="small"
            />
          )}
          <IconButton color="secondary" aria-label="Edit" onClick={() => onEditVessel(vessel)}>
            <EditIcon />
          </IconButton>
        </Box>
      );
    }
  }
];

export default getVesselsGridColumns;
